import { combineReducers } from 'redux'

import availablePlans from './availableSubscriptionPlans'
import companySubscription from './companySubscription'
import coupon from './couponReducer'
import settings from './settings'

export default combineReducers({
  availablePlans,
  companySubscription,
  settings,
  coupon,
})
